import { render } from "./TotalUpdateData.vue?vue&type=template&id=4e90298f"
import script from "./TotalUpdateData.vue?vue&type=script&lang=js"
export * from "./TotalUpdateData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__